// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import ShaderLib from '../renderer/shaders/ShaderLib';
import RenderTarget from '../renderer/pass/RenderTarget';
import FullscreenPass from '../renderer/pass/FullscreenPass';
import Pass from '../renderer/pass/Pass';
import ShaderLibExtra from './ShaderLibExtra';

class MotionBlurPass extends Pass {
  constructor() {
    super();
    this.inPass = new FullscreenPass(ShaderLibExtra.motionBlurPassBlendShader);
    this.outPass = new FullscreenPass(ShaderLib.copyPure);

    const width = window.innerWidth || 1024;
    const height = window.innerHeight || 1024;
    this.updateSize({
      x: 0,
      y: 0,
      width,
      height,
    });
    this.enabled = true;
    this.clear = false;
    this.needsSwap = true;
  }

  destroy(renderer) {
    this.inPass.destroy(renderer);
    this.outPass.destroy(renderer);
    if (this.targetSwap) {
      this.targetSwap[0].destroy(renderer.context);
      this.targetSwap[1].destroy(renderer.context);
      this.targetSwap = undefined;
    }
  }

  invalidateHandles(renderer) {
    this.inPass.invalidateHandles(renderer);
    this.outPass.invalidateHandles(renderer);
    renderer.invalidateRenderTarget(this.targetSwap[0]);
    renderer.invalidateRenderTarget(this.targetSwap[1]);
  }

  updateSize(size, renderer) {
    const sizeX = size.width;
    const sizeY = size.height;

    if (this.targetSwap) {
      for (let i = 0; i < this.targetSwap.length; i++) {
        renderer._deallocateRenderTarget(this.targetSwap[i]);
      }
    }

    this.targetSwap = [
      new RenderTarget(sizeX, sizeY),
      new RenderTarget(sizeX, sizeY),
    ];
  }

  render(renderer, writeBuffer, readBuffer) {
    this.inPass.material.setTexture('MOTION_MAP', this.targetSwap[1]);
    this.inPass.render(renderer, this.targetSwap[0], readBuffer);
    this.outPass.render(renderer, writeBuffer, this.targetSwap[0]);
    this.targetSwap.reverse();
  }
}

export default MotionBlurPass;
